import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import type { BreadcrumbItem } from '../../../hooks/useBreadcrumbs';

interface AppBreadcrumbProps {
  items: BreadcrumbItem[];
  isMobile?: boolean;
}

/**
 * Breadcrumb padronizado do layout principal.
 */
export const AppBreadcrumb: React.FC<AppBreadcrumbProps> = ({ items, isMobile = false }) => {
  if (items.length === 0) {
    return null;
  }

  const breadcrumbItems = items.map((crumb, index) => {
    const isLast = index === items.length - 1;

    if (isLast || !crumb.path) {
      return { title: crumb.title };
    }

    return {
      title: (
        <Link
          to={crumb.path}
          style={{
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center',
            color: 'inherit',
            textDecoration: 'none',
          }}
          onMouseEnter={(event) => {
            event.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(event) => {
            event.currentTarget.style.textDecoration = 'none';
          }}
        >
          {crumb.title}
        </Link>
      ),
    };
  });

  return (
    <Breadcrumb
      items={breadcrumbItems}
      separator=">"
      style={{
        lineHeight: '64px',
        maxWidth: isMobile ? 'calc(100vw - 160px)' : undefined,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}
    />
  );
};

export default AppBreadcrumb;
